import { ErrorService } from './../../../@core/utils/error.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  NbCardModule,
  NbChatModule,
  NbDialogRef,
  NbListModule,
  NbPopoverModule,
  NbTooltipModule,
} from '@nebular/theme';
import { KPI } from '../../../@core/api';
import { ScopeService, WorkflowService } from '../../../@core/utils';
import { FormsModule } from '@angular/forms';
import { NgFor } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommentsComponent } from '../comments/comments.component';

@Component({
  selector: 'app-workflow-comment-dialog',
  styleUrls: ['./workflow-comment-dialog.component.scss'],
  templateUrl: './workflow-comment-dialog.component.html',
  standalone: true,
  imports: [
    NbCardModule,
    FontAwesomeModule,
    FormsModule,
    TranslateModule,
    CommentsComponent,
    NbChatModule,
    NgFor,
    NbTooltipModule,
    NbPopoverModule,
    NbListModule,
  ],
})
export class WorkflowCommentDialogComponent implements OnInit {
  @Input() public round: KPI.WorkflowRound | KPI.WorkflowRoundHistory;
  @Input() public site: KPI.WorkflowSite;
  @Input() public step: KPI.WorkflowStep;
  @Input() public comments: KPI.WorkflowRoundStepComment[];

  @Output() added: EventEmitter<KPI.WorkflowRoundStepComment> = new EventEmitter<KPI.WorkflowRoundStepComment>();
  @Output() updated: EventEmitter<KPI.WorkflowRoundStepComment> = new EventEmitter<KPI.WorkflowRoundStepComment>();
  @Output() deleted: EventEmitter<KPI.WorkflowRoundStepComment> = new EventEmitter<KPI.WorkflowRoundStepComment>();

  public commentTitle = this.translate.instant('pages.workflow.comments.add-comment-title');

  public isFormVisible = false;
  public user: KPI.User = null;
  public canAddComment: boolean = true;

  constructor(
    private workflowService: WorkflowService,
    private ref: NbDialogRef<WorkflowCommentDialogComponent>,
    private translate: TranslateService,
    private scopeService: ScopeService,
    private errorService: ErrorService,
  ) {
  }

  public ngOnInit(): void {
    this.isFormVisible = (this.comments.length === 0);
    this.scopeService.user$.subscribe((user) => {
      if (user) {
        this.user = user;
      }
    });
  }

  public submit(): void {
    this.ref.close();
  }

  public postComments(comment: string) {
    if (!comment || comment.trim().length === 0) {
      return;
    }
    this.canAddComment = false;
    this.workflowService.postComment(
      this.round, this.site, this.step, comment,
    ).subscribe({
      next: (comment: KPI.WorkflowRoundStepComment) => {
        this.added.emit(comment);
        this.comments.push(comment);
        this.canAddComment = true;
      },
      error: (error: Error) => {
        this.errorService.handleError(error, true);
      },
      complete: () => {
      },
    });

  }

  public safeCommentText(comment: KPI.WorkflowRoundStepComment): string {
    return comment.text.split('\n').join('<br />');
  }

  public exit(event) {
    event.preventDefault();
    this.ref.close();
  }

  protected readonly close = close;
}
